export enum FontSizeData_fontType {
  PX = 'PX',
  EM = 'EM',
  UNRECOGNIZED = 'UNRECOGNIZED',
}